import type * as React from "react";
import { type LocationChangeAction } from "../../_Bootstrap/RoutingAndStore";
import { type ShopfrontThunk } from "../../Utilities/Generic/ActionsHelper";
import UUID from "../../Utilities/Generic/UUID";
import {
    type BodyClickAction,
    type BodyDisplayOverlayAction,
    type BodyHideOverlayAction,
    displayOverlay,
    hideOverlay,
    type NotificationToggleAction,
    type ToggleMenuAction,
    type UserMenuToggleAction,
} from "../General/LayoutActions";

export const DIALOG_SHOW = "DIALOG_SHOW";
export const DIALOG_HIDE = "DIALOG_HIDE";
export const DIALOG_CLICK = "DIALOG_CLICK";

export type DialogTypes = "danger" | "information" | "question" | "success" | "error" | "warning" | "edit";

export type DialogButtonCallback = (
    event: React.MouseEvent<HTMLButtonElement>
) => (boolean | void | Promise<void | boolean>);

export type DialogOptions = {
    label: string | React.ReactNode;
    classes: Array<string>;
    callback?: DialogButtonCallback;
    autoFocus?: boolean;
};

interface DialogData {
    id: string;
    dialogType: DialogTypes;
    header: string;
    content: React.ReactNode;
    options: Array<DialogOptions> | false;
    focus: boolean;
    closeable: boolean;
    showFrame: boolean;
    hasBackground: boolean;
    overLogin: boolean;
}

export interface ShowDialogAction {
    type: typeof DIALOG_SHOW;
    data: DialogData;
}

export interface HideDialogAction {
    type: typeof DIALOG_HIDE;
    delay?: boolean | number;
}

export type DialogActionTypes =
    ShowDialogAction |
    HideDialogAction |
    ToggleMenuAction |
    BodyClickAction |
    UserMenuToggleAction |
    NotificationToggleAction |
    LocationChangeAction;

export interface DialogState extends Partial<DialogData> {
    visible: boolean;
    delay?: number;
}

export function showDialog(
    header: string,
    content: React.ReactNode,
    type: DialogTypes,
    options: Array<DialogOptions> | false = false,
    focus = true,
    closeable = true,
    showFrame = true,
    hasBackground = true,
    overLogin = false,
    id?: string
): ShopfrontThunk<BodyDisplayOverlayAction | ShowDialogAction> {
    if(typeof id === "undefined") {
        id = UUID.generate();
    }

    return (dispatch): void => {
        if(closeable) {
            dispatch(displayOverlay());
        }

        dispatch({
            type: DIALOG_SHOW,
            data: {
                id        : id as string,
                dialogType: type,
                header,
                content,
                options,
                focus,
                closeable,
                showFrame,
                hasBackground,
                overLogin,
            },
        });
    };
}

export function hideDialog(delay?: number): ShopfrontThunk<BodyHideOverlayAction | HideDialogAction> {
    return (dispatch): void => {
        dispatch(hideOverlay());
        dispatch({
            type: DIALOG_HIDE,
            delay,
        });
    };
}
